export const ApplicationBrand = {
    brandName: ' ETR Field Force - HQ'
};

export const MenuItems = {
    "applicationItem": {
        "data": [
            {
                parentID: 1,
                item: [
                    {
                        itemTitle: "Coverage Reports",
                        itemList: [
                            {
                                id: '1',
                                name: "Coverage Summary Report",
                                icon: "/Images/graph-bar.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            },
                            {
                                id: '2',
                                name: "Attendance Report",
                                icon: "/Images/outline-inventory.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            },
                        ]
                    }
                ]
            }
        ]
    }
};

export const ApplicationItems = {
    "applications": [
      {
        name: "Coverage",
        icon: "/Images/graph-bar.svg",
        modules: [
          {
            id: 8,
            name: "Dashboard",
            icon: "/Images/dashboard.svg",
            roleLevel: "0",
            path: "/dashboards",
            children: [
              {
                menuHeader: "Sales Reports (Salesforce)"
              },
              {
                id: 1,
                name: "Coverage Summary Report",
                icon: "/Images/graph-bar.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                id: 2,
                name: "Attendance Report",
                icon: "/Images/outline-inventory.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
            ]
          }
        ]
      }
    ]
  }